//(function ($) {

//    // Related links
//    $('.related-links-wrap h2').click(function() {
//        $(this).parents('.related-links-wrap').toggleClass('links-open');
//    });

//    // On this page links
//    $('.anchor-links-wrap h4').click(function() {
//        $(this).parents('.anchor-links-wrap').toggleClass('anchors-open');
//    });
//})(jQuery);